<template>
  <v-jumbotron>
    <v-container fill-height>
      <v-layout align-center>
        <v-flex>
          <h4 class="display-2 my-3">
            Your profile
          </h4>

          <span class="subheading">
            <p>Access your user profile using the button (<v-icon>account_circle</v-icon>) at top right. If you need to reset your password, you can do so via the profile page. For assistance, please use the Discussion forum.</p>
            <p>
              Good luck, have fun!
            </p>
          </span>
          <v-divider class="my-3"></v-divider>
          <!-- <div class="title my-4">?</div> -->
          <v-btn color="primary" dark class="mx-0" to="challenge-description">Go to Challenge Description</v-btn>
        </v-flex>
      </v-layout>
    </v-container>
  </v-jumbotron>

</template>

<script>
  export default {
    name: 'Tour6',
    data () {
      return {
        // foo: 'bar'
        // gradient: '315deg, #3f87a6, #f69d3c',
      }
    },
    mounted () {
      // console.log('Tour4 component mounted')
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/Tour/Tour6.vue